import { Helpers } from '../../helpers';
import { IBullpenClassification } from '../../interfaces/ibullpen-classification';
import { ScenarioWell } from '../scenario-well';

export class BullpenClassificationBase {
  BullpenClassificationId: number;
  Description: string;
  SortOrder: number | null;
  MinLeadTime: number | null;
  MaxLeadTime: number | null;
  DefaultLeadTime: number | null;
  AssetTeamId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScenarioWells_BullpenClassification?: Array<ScenarioWell> | null;

  constructor(item?: IBullpenClassification) {
    if (item) {

      this.BullpenClassificationId = item.BullpenClassificationId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.MinLeadTime = item.MinLeadTime;
      this.MaxLeadTime = item.MaxLeadTime;
      this.DefaultLeadTime = item.DefaultLeadTime;
      this.AssetTeamId = item.AssetTeamId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScenarioWells_BullpenClassification = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_BullpenClassification);
    }
  }
}